export enum UserRole {
    CONSULTANT_HQ = 'CONSULTANT_HQ',
    CHIEF_INSPECTOR = 'CHIEF_INSPECTOR',
    INSPECTOR = 'INSPECTOR',
    SUPER_ADMIN = 'SUPER_ADMIN'
}

// Structure pour l'affichage des rôles
export interface RoleOption {
    value: UserRole;
    label: string;
}

// Constante pour les options de rôles avec leurs labels traduits
export const ROLE_OPTIONS: RoleOption[] = [
    {
        value: UserRole.CONSULTANT_HQ,
        label: 'roles.consultant_hq'
    },
    {
        value: UserRole.CHIEF_INSPECTOR,
        label: 'roles.chief_inspector'
    },
    {
        value: UserRole.INSPECTOR,
        label: 'roles.inspector'
    },
    {
        value: UserRole.SUPER_ADMIN,
        label: 'roles.super_admin'
    }
];
